module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./GuangView.js"));
	}, "GuangView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GuangView!./src/pages/Shop/Guang/GuangView.js
// module id = 913
// module chunks = 431